import React, {useRef, useEffect, useState} from 'react';
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import "./Main.scss";

import {
    Home,
    PackMan,
    Login,
    Verify, PackManDetail, Peyk, PeykDetail, PeykMap,

} from "./Pages";
import {Route, useHistory, withRouter} from "react-router-dom";
import ProtectedRoute from "./Components/ProtectedRoute";
import 'toasted-notes/src/styles.css';
import "./pageTransitions/slideTransition.scss";
import {SideBar} from "./Components/Sidebar/SideBar.js";
import {
    useDispatchMall,
    useDispatchPrompt,
    useDispatchRoot,
    useDispatchStore,
    usePrompt,
    useStore
} from "./hooks";

import {VerifyCustomer} from "./Pages/VerifyCustomer/VerifyCustomer";
import {NotificationAllow} from "./Components";
import ReactGA from 'react-ga';
import {LocalPush} from "./Services";
import {PackManAdd} from "./Pages/PackMan/PackManAdd/PackManAdd";
import {SendManagement} from "./Pages/SendManagement/SendManagement";
import {PeykBachMap} from "./Pages/Peyk/PeykMap/PeykBachMap";
import {Geofence} from "./Pages/Geofence/Geofence";
import {GeofenceOne} from "./Pages/Geofence/GeofenceOne";
import {AddMerchant} from "./Pages/AddMerchant/AddMerchant";
import Merchants from "./Pages/Merchants/Merchants";
import Creditor from "./Pages/Creditor/Creditor";


function OverSize() {
    return(
        <div id="overSize-container">
            <img src="/other/logo.png" alt=""/>
        </div>
    )
}




function App() {

    //hooks
    const setPrompt = useDispatchPrompt();
    const history = useHistory();
    const setSelect = useDispatchRoot();
    const setMall = useDispatchMall();
    const prompt = usePrompt();
    const inputRef = useRef(null)
    const fire = useStore();
    const setFire = useDispatchStore();

    //states -----
    const [body, setBody] = useState("nottt");
    const [toke, setToke] = useState("nottt");


    useEffect(() => {


        const beforeInstallListener = e => {
            e.preventDefault();
            // console.log("BEFORaE : ",e);
            setPrompt(e);
            setBody("install");
        };

        // console.log("App Init ...")


        window.addEventListener("beforeinstallprompt", beforeInstallListener);

        navigator.serviceWorker.addEventListener("message", (message) => {
            try{
                // console.log(message.data);
                // setBody(JSON.stringify(message.data));
                let notif = message.data["firebase-messaging-msg-data"].notification;
                // console.log(notif)
                LocalPush({title:notif.title,body:notif.body,image:notif.image,url:notif.click_action})
            }catch (e) {
                // setBody(JSON.stringify(e));
                // console.log(e)
            }
        });

        let uid = "0"
        let cId = "0"
        let user = localStorage.getItem('user');
        if(user) {
            let parsed_user = JSON.parse(user);
            uid = parsed_user.uid;
            cId = parsed_user.phone
        }

        ReactGA.initialize('UA-175496552-1', {
            debug: false,
            titleCase: false,
            gaOptions: {
                userId: uid,
                clientId: cId
            }
        });


        // const trackingId = "UA-175496552-1"; // Replace with your Google Analytics tracking ID
        // ReactGA.initialize(trackingId);
        // ReactGA.initialize('UA-175496552-1', {
        //     debug: true,
        //     titleCase: false,
        //     gaOptions: {
        //         userId: 123,
        //         clientId: 'some-unique-id'
        //     }
        // });

        history.listen(location => {
            setSelect(location.pathname);
            ReactGA.set({ page: location.pathname }); // Update the user's current page
            ReactGA.pageview(location.pathname); // Record a pageview for the given page
        });

    }, [])






    return (
        <>
            <OverSize/>
            <div className="main_container" id="App">
                <SideBar pageWrapId={"page-wrap"} outerContainerId={"App"} />
                <div id="page-wrap">
                    {/*Protected Route*/}
                    <ProtectedRoute  path='/' exact component={PackMan} />

                    {/*Pack Man Route*/}
                    <ProtectedRoute  path='/merchants' exact component={Merchants} />
                    <ProtectedRoute  path='/pack-man' exact component={PackMan} />
                    <ProtectedRoute  path='/pack-man/:id' exact component={PackManDetail} />
                    <ProtectedRoute  path='/pack-man/:id/add' exact component={PackManAdd} />
                    {/*Send Management Route*/}
                    <ProtectedRoute  path='/send-management' exact component={SendManagement} />
                    {/*Peyk Route*/}
                    <ProtectedRoute  path='/peyk' exact component={Peyk} />
                    <ProtectedRoute  path='/creditor' exact component={Creditor} />
                    <ProtectedRoute  path='/peyk/:id' exact component={PeykDetail} />
                    <ProtectedRoute  path='/map' exact component={PeykMap} />
                    {/*Add Merchant*/}
                    <ProtectedRoute  path='/add-merchant' exact component={AddMerchant} />
                    <ProtectedRoute  path='/maps' exact component={PeykBachMap} />

                    {/*Public Route*/}
                    <Route path={"/verify"} component={Verify}/>
                    <Route path={"/verify-customer"} component={VerifyCustomer}/>
                    <Route path={"/login"} component={Login}/>
                    <Route  path='/adds' exact component={PeykBachMap} />

                    {/*Geofence Route*/}
                    <Route path={"/geofence"} component={GeofenceOne}/>
                </div>

                {/*<NotificationAllow/>*/}

            </div>
        </>
    );
}

export default withRouter(App);
